import { Microfrontend } from '@cian/mf-react';
import { noop } from 'lodash';
import * as React from 'react';

import { useAdsDisabled } from '../../../hooks/useAdsDisabled';

type TMicrofrontendElement = React.ElementRef<typeof Microfrontend>;

/**
 * Монтирует микрофронтенд строго на клиенте: рекламу нельзя рендерить на SSR.
 *
 * `isReady` поднимается в `true` только после полной загрузки страницы (`window.load`),
 * как это делал легаси-баннер через `useAdsDisabled`/`usePageLoaded` (CD-280813):
 * runtime МКФ, context.js и креатив не должны конкурировать за сеть и main thread
 * с контентом страницы (рекомендации, фильтры) на старте. Дополнительный бонус —
 * к этому моменту антиадблок-детектор уже выставил `window._cianCanRunAds`,
 * и `getCanRunAds` внутри МКФ отрабатывает так же, как в легаси.
 *
 * Место под баннер до маунта держит плейсхолдер (без CLS).
 */
export function useAdBannerMicrofrontend() {
  const microfrontendRef = React.useRef<TMicrofrontendElement | null>(null);

  const isAdsDisabled = useAdsDisabled(noop, []);

  return { microfrontendRef, isReady: !isAdsDisabled };
}
